import {
    PRINT_CUSTOMIZABLE_PDF,
    PRINT_PDF_LOADING,
    PRINT_PDF_FOR_TEXT,
    PRINT_PDF_FOR_EMAIL,
    SET_PDF_URL_FOR_SHARING,
    CLEAR_PDF_URL_FOR_SHARING,
    PRINT_PDF_RESET_SUCCESS,
    PRINT_PDF_SUCCESS,
    PUBLISH_TO_SHOWROOM,
    GENERATE_PDF
} from '../actionTypes/printPdfActionTypes';
import type { ForSharing, ScopeGridSelections, SharingType } from '../types/types';

export const printCustomizablePdf = (
    selectedProposalId?: string,
    selectedScopeIds?: string[],
    scopeGridSelections?: ScopeGridSelections
) => {
    return {
        type: PRINT_CUSTOMIZABLE_PDF,
        payload: { selectedProposalId, selectedScopeIds, scopeGridSelections }
    };
};

export const publishToShowroom = (
    selectedProposalId?: string,
    selectedScopeIds?: string[],
    scopeGridSelections?: ScopeGridSelections
) => {
    return {
        type: PUBLISH_TO_SHOWROOM,
        payload: { selectedProposalId, selectedScopeIds, scopeGridSelections }
    };
};

export const printPdfForText = (
    selectedProposalId?: string,
    selectedScopeIds?: string[],
    scopeGridSelections?: ScopeGridSelections
) => {
    return {
        type: PRINT_PDF_FOR_TEXT,
        payload: { selectedProposalId, selectedScopeIds, scopeGridSelections }
    };
};

export const printPdfForEmail = (
    selectedProposalId?: string,
    selectedScopeIds?: string[],
    scopeGridSelections?: ScopeGridSelections
) => {
    return {
        type: PRINT_PDF_FOR_EMAIL,
        payload: { selectedProposalId, selectedScopeIds, scopeGridSelections }
    };
};

export const setPdfUrlForSharing = (url: string, type: SharingType) => {
    return {
        type: SET_PDF_URL_FOR_SHARING,
        payload: { url, type }
    };
};

export const clearPdfUrlForSharing = () => {
    return {
        type: CLEAR_PDF_URL_FOR_SHARING
    };
};

export const printPdfLoading = (loading: boolean, forSharing: ForSharing = false, isPublishing = false) => {
    return {
        type: PRINT_PDF_LOADING,
        payload: {
            loading,
            forSharing,
            isPublishing
        }
    };
};

export const printPdfResetSuccess = () => {
    return {
        type: PRINT_PDF_RESET_SUCCESS
    };
};

export const printPdfSuccess = () => {
    return {
        type: PRINT_PDF_SUCCESS
    };
};

export const generatePdf = (type: string) => {
    return {
        type: GENERATE_PDF,
        payload: { type }
    };
};
